import { EnvironmentProviders, Injectable, makeEnvironmentProviders, OnDestroy } from '@angular/core';
import { IconsNotifier } from '@bcf-icons/svg/common';
import {
  WorkerSynchronizerSimple,
  WorkerSynchronizerSpawner
} from '@bcf-v2-platforms/platform-worker/worker-synchronizer';
import { Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
class IconsNotifierBrowser extends IconsNotifier implements OnDestroy {
  private _destroy$: Subject<void> = new Subject();
  constructor(private _workerSynchronizerSpawner: WorkerSynchronizerSpawner) {
    super();
    const iconsNotifierChannel: WorkerSynchronizerSimple =
      this._workerSynchronizerSpawner.spawnRaw('iconsNotifierChannel');
    iconsNotifierChannel.message$.pipe(takeUntil(this._destroy$)).subscribe(() => this.iconsLoaded$.next(undefined));
  }
  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}

export function provideIconsNotifierBrowser(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: IconsNotifier,
      useClass: IconsNotifierBrowser
    }
  ]);
}
